import { gql } from '@apollo/client'

export const SUGGESTED_AGENTS_QUERY = gql`
  query suggestedAgents(
    $processingId: ID!
    $limit: Int
    $ignoreAvailability: Boolean
    $assignedProcessingTypeId: ID
    $actualProcessingTypeId: ID
  ) {
    suggestedAgents(
      processingId: $processingId
      limit: $limit
      ignoreAvailability: $ignoreAvailability
      assignedProcessingTypeId: $assignedProcessingTypeId
      actualProcessingTypeId: $actualProcessingTypeId
    ) {
      user {
        id
        altName
        email
        employeeHohner
        avatar {
          url
        }
        mediatorProfile {
          specialNotes
          mediatorTags {
            id
            name
          }
        }
      }
      score
      employeeHohner
      legalAreaMatch
      casesReceived
      maxCases
      remainingHours
      capacityRatio
      capacityStatus
      feedbackRate
      completionRate
      availableFrom
      exclusionReasons
      previousWeekCases
      previousWeekMax
      matchedTags {
        name
      }
      missingTags {
        name
      }
      dailyAvailability
      casesReceivedToday
      maxCasesToday
      weeklyNotes
      assignmentDate
      languageMatch
      rejectedProcessing
      saturated
      saturationReason
    }
  }
`

export const EVALUATE_AGENT_QUERY = gql`
  query evaluateAgent(
    $processingId: ID!
    $userId: ID!
    $assignedProcessingTypeId: ID
    $actualProcessingTypeId: ID
  ) {
    evaluateAgent(
      processingId: $processingId
      userId: $userId
      assignedProcessingTypeId: $assignedProcessingTypeId
      actualProcessingTypeId: $actualProcessingTypeId
    ) {
      user {
        id
        altName
        email
        employeeHohner
        avatar {
          url
        }
        mediatorProfile {
          specialNotes
          mediatorTags {
            id
            name
          }
        }
      }
      score
      employeeHohner
      legalAreaMatch
      casesReceived
      maxCases
      remainingHours
      capacityRatio
      capacityStatus
      feedbackRate
      completionRate
      availableFrom
      exclusionReasons
      previousWeekCases
      previousWeekMax
      matchedTags {
        name
      }
      missingTags {
        name
      }
      dailyAvailability
      casesReceivedToday
      maxCasesToday
      weeklyNotes
      assignmentDate
      languageMatch
      rejectedProcessing
      saturated
      saturationReason
    }
  }
`

export const CREATE_AGENT_SUGGESTION_FEEDBACK = gql`
  mutation createAgentSuggestionFeedback($attributes: AgentSuggestionFeedbackInput!) {
    createAgentSuggestionFeedback(attributes: $attributes) {
      id
    }
  }
`
